import { useAuthStore } from "@/stores/auth-store";
import keycloak from "./keycloak";
// import { useAuthStore } from "./authStore";

export async function initKeycloak() {
  try {
    const authenticated = await keycloak.init({
      onLoad: "login-required", // эсвэл 'check-sso'
      checkLoginIframe: false,
    });

    if (authenticated && keycloak.token) {
      useAuthStore
        .getState()
        .setToken(keycloak.token, keycloak.refreshToken || "");
      console.log("✅ Authenticated");

      // Auto-refresh loop
      setInterval(async () => {
        try {
          const refreshed = await keycloak.updateToken(60);
          if (refreshed && keycloak.token) {
            console.log("🔄 Token refreshed");
            useAuthStore
              .getState()
              .setToken(keycloak.token, keycloak.refreshToken || "");
          }
        } catch (err) {
          console.warn("❌ Failed to refresh token", err);
          useAuthStore.getState().clearToken();
          keycloak.logout();
        }
      }, 6000);
    } else {
      console.warn("❌ Not authenticated");
      useAuthStore.getState().clearToken();
    }
  } catch (err) {
    console.error("Keycloak init error", err);
  }
}

export function login() {
  keycloak.login();
}

export function logout() {
  keycloak.logout();
}
